/**
 * components/support/support-contact.ts
 *
 * The support mailbox and its promised reply time, for the in-product screens.
 *
 * The address itself lives in `legal/companyDetails.ts` with the rest of the
 * company's public facts; this module is what the in-product screens import,
 * so none spells out an address of its own. The way to ask is "Ask Optivo"
 * (`AskOptivoRail`); the address appears only where a request cannot be sent
 * (a refusal, the setup choice's fallback).
 */

import { COMPANY } from "../legal/companyDetails";

/** The public support mailbox, as published on the legal pages. */
export const SUPPORT_EMAIL = COMPANY.supportEmail;

/** How long a customer waits for an answer, in hours. */
export const SUPPORT_RESPONSE_HOURS = COMPANY.supportResponseHours;
